import { DraftCloseActionSelectModal } from '../../Draft'

function EmailDraftCloseActionSelectModal(props) {
  return (
    <DraftCloseActionSelectModal
      {...props}
      cancelTextKey='Email.CloseConfirmationCancelKey'
      discardLabelKey='Email.CloseConfirmationDiscardKey'
      formFieldsProps={{ titleKey: 'Email.CloseConfirmationActionTitleKey' }}
      saveLabelKey='Email.CloseConfirmationSaveKey'
      submitTextKey='Email.CloseConfirmationSubmitKey'
      titleKey='Email.CloseConfirmationTitleKey'
    />
  )
}

export default EmailDraftCloseActionSelectModal
